
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import HelpIcon from '@material-ui/icons/Help'
import Tooltip from '@material-ui/core/Tooltip'
import {
  Grid,
  Typography,
  IconButton,
  ClickAwayListener,
  withStyles
} from '@material-ui/core'

const styles = theme => ({
  helpContainer: {
    textAlign: 'right'
  },
  lightTooltip: {
    background: theme.palette.common.white,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[1],
    fontSize: 11,
  }
})

class FormHeader extends Component {
  constructor() {
    super()
    this.state = {
      open: false
    }
  }

  handleTooltipClose = () => {
    this.setState({ open: false });
  }

  toggleToolTip = () => {
    this.setState({ open: !this.state.open });
  }


  render() {
    const { description, stepNumber, title, helpText, classes } = this.props

    return (
      <React.Fragment>
        <Grid item xs={10} container alignItems="center">
          <Grid item xs>
            <Typography variant="title">{stepNumber}</Typography>
          </Grid>
          {helpText && (
            <Grid item xs className={classes.helpContainer}>
              <ClickAwayListener onClickAway={this.handleTooltipClose}>
                <Tooltip
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  title={helpText}
                  classes={{ tooltip: classes.lightTooltip }}
                  open={this.state.open}
                >
                  <IconButton>
                    <HelpIcon
                      onClick={this.toggleToolTip}
                      color="primary"
                    />
                  </IconButton>
                </Tooltip>
              </ClickAwayListener>
            </Grid>
          )}
        </Grid>
        {title && (
          <Grid item xs={10}>
              <Typography variant="headline">{title}</Typography>
          </Grid>
        )}
        <Grid item xs={10}>
          <Typography variant="subheading">
            {Array.isArray(description) ?
              description.map(text => `${text} `) : description
            }
          </Typography>
        </Grid>
      </React.Fragment>
    )
  }
}

FormHeader.propTypes = {
  description: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.element,
    PropTypes.string
  ]),
  stepNumber: PropTypes.string,
  title: PropTypes.string,
  helpText: PropTypes.string,
  classes: PropTypes.object
}

export default withStyles(styles)(FormHeader)


// WEBPACK FOOTER //
// ./src/components/counseling-session/FormHeader.js